import React from "react";

import Footer from "@components/Footer/footer";
import Header from "@components/Header/header";
import PasswordModal from "@components/Modal/passwordModal";
import Spinner from "@components/Spinner/spinner";
import Toasts from "@components/Toast/toasts";
import { withTrans } from "@components/WithTrans/WithTrans";
import UserModal from "@pages/Users/userModal";
import CompanyModal from "@pages/Company/companyModal";
import Routes from "@routes/routes";
import "@samskip/frontend-components/dist/index.css";
import { AppState, ModalType, ViewState } from "@state/reducers/types";
import { useTranslation, Translation } from "react-i18next";
import { connect } from "react-redux";

const Layout: React.FC<ViewState> = ({ modalOpen, modalType }) => {
  const { ready } = useTranslation();

  if (!ready) {
    return (
      <div className="h-screen flex flex-col">
        <Spinner />
      </div>
    );
  }

  return (
    <Translation>
      {(t) => (
        <div className="flex flex-col bg-light-gray h-full w-full">
          <Header />
          <Toasts />
          {modalOpen && modalType === ModalType.COMPANY_MODAL && <CompanyModal/>}
          {modalOpen && modalType === ModalType.USER_MODAL && <UserModal />}
          <PasswordModal
            header={t("LABEL_LOGIN")}
            open={modalOpen && modalType === ModalType.PASSWORD_MODAL}
          />
          <div className="flex flex-col flex-grow overflow-y-auto h-auto">
            <Routes />
            <Footer />
          </div>
        </div>
      )}
    </Translation>
  );
};

export default withTrans(
  connect(
    (state: AppState) => ({
      modalOpen: state.ViewReducer.modalOpen,
      modalType: state.ViewReducer.modalType,
    }),
    {}
  )(Layout)
);
